
const digest = 'db158ec8443a78d72f9ebd43f2e2d21e308dd460f5eaf907241350b0a726e648';
const classes = {"title":"_title_pxxim_1","list":"_list_pxxim_8"};
const css = `._title_pxxim_1 {
  font-family: Poppins, sans-serif;
  color: #212357;
  font-weight: 600;
  font-size: 16px;
}

._list_pxxim_8 {
  display: flex;
  flex-direction: column;
  gap: 10px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  